<template>
  <v-chip :color="delegationStatusExtended.find(v => v.value === status).color" text-color="white">
    {{ delegationStatusExtended.find(v => v.value === status).text }}
  </v-chip>
</template>

<script>
import { delegationStatusExtended } from "../../staticData/Delegation";
export default {
  name: "DelegationStatusChip",
  props: {
    status: {
      required: true
    }
  },
  computed: {
    delegationStatusExtended
  }
};
</script>

<style scoped></style>
